import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { AvatarComponent } from '../../components/avatar/avatar.component';
import { ItemErrorComponent } from '../../components/item-form-error/item-form-error.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Session from '../../utils/session.service';
import ServiceRestServices from '../../services/service-rest.service';
import Toast from '../../services/toast.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	standalone: true,
	selector: 'modal-booking-enquiry',
	templateUrl: './modal-booking-enquiry.component.html',
	imports: [ CommonModule, TranslatePipe, LoaderOverlayComponent, AvatarComponent, ItemErrorComponent, FormsModule ]
})
export class ModalBookingEnquiryComponent implements OnInit {
	private session: Session = inject(Session);
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private toast: Toast = inject(Toast);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private dialogRef = inject(MatDialogRef<ModalBookingEnquiryComponent>);
	private data = inject(MAT_DIALOG_DATA);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.vm.service = this.vm.service || {};
		if (!this.vm.communicationType) {
			if (this.vm.service.typeOfAppointment === 'VIDEO_SESSION_ONLY') {
				this.vm.communicationType = 'VIDEO';
			} else if (this.vm.service.typeOfAppointment === 'FACE_TO_FACE_SESSION_ONLY') {
				this.vm.communicationType = 'FACE_TO_FACE';
			}
		}
		this.vm.uid = 'br-' + Date.now();
		this.vm.user = this.angularHelperService.copy(this.session.getSession().user);
		this.vm.data = {
			firstname: this.vm.user.firstname,
			lastname: this.vm.user.lastname,
			email: this.vm.user.email,
			phone: this.vm.user.phone
		};
		
		this.vm.close = this.close;
		this.vm.handleFormSubmit = this.handleFormSubmit;
	}
	
	handleFormSubmit(mainForm: any) {
		this.vm.submitted = true;
		if (mainForm.invalid) return;
		this.vm.processing = true;
		
		var data: any = this.angularHelperService.copy(this.vm.data);
		data.businessService = { id: this.vm.service.id };
		data.user = {id: this.vm.user.id};
		data.communicationType = this.vm.communicationType;
		
		this.serviceRestServices.createRequest(data, (res) => {
			this.close();
			this.toast.show(this.angularFilterHelperService.translate('Toast.Service.Message_Sent'));
		});
	}
	
	close() {
		this.dialogRef.close();
	}
	
}
